const screens = {
  sm: "640px",
  // => @media (min-width: 640px) { ... }

  md: "768px",
  // => @media (min-width: 768px) { ... }

  lg: "1024px",
  // => @media (min-width: 1024px) { ... }

  /*
   * Oyster designers won't design for these breakpoints, but these are here in case we run into edge cases on larger screens
   */

  xl: "1280px",
  // => @media (min-width: 1280px) { ... }

  "2xl": "1536px",
  // => @media (min-width: 1536px) { ... }

  /**
   * This should only be used in the scenario of max-w-screen-container
   * This is calculated from 1169px (max content width according to Page Templates), + 40px (padding left) + 40px (padding right)
   * See Storybook documentation on Page Templates for more information
   */
  container: "1249px",
}

module.exports = {
  screens,
}

exports.default = screens
